import {
  IRequirementResponse,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";

/**
 * Priority mapping for requirement types.
 * Lower numbers appear first in sorted lists.
 */
const REQUIREMENT_TYPE_PRIORITY: Record<RequirementType, number> = {
  [RequirementType.Registration]: 1,
  [RequirementType.TaxVerification]: 2,
  [RequirementType.PayoutMethod]: 3,
  [RequirementType.Signature]: 4,
  [RequirementType.SharedFile]: 4,
  [RequirementType.BackgroundCheck]: 4,
  [RequirementType.IdentityVerification]: 4,
  [RequirementType.InsuranceCoverage]: 4
};

/**
 * Sorts requirements by priority order:
 * 1. Registration
 * 2. Tax Verification
 * 3. Payout Method
 * 4. Others (Signature, SharedFile, BackgroundCheck, IdentityVerification, InsuranceCoverage)
 *
 * @param requirements - Array of requirements to sort
 * @returns New array sorted by priority (does not mutate original)
 */
export function sortRequirementsByPriority<T extends IRequirementResponse>(
  requirements: T[]
): T[] {
  return [...requirements].sort((a, b) => {
    const priorityA = REQUIREMENT_TYPE_PRIORITY[a.requirementType] ?? 999;
    const priorityB = REQUIREMENT_TYPE_PRIORITY[b.requirementType] ?? 999;
    return priorityA - priorityB;
  });
}
